import {
    Box,
    Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import {
    Border,
    Spacing,
} from '@uipath/apollo-core';
import { ApSkeleton } from '@uipath/portal-shell-react';
import React from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        skeletonServiceName: {
            maxWidth: '35%',
            height: 20,
            borderRadius: Border.BorderRadiusM,
        },
        skeletonServiceAmount: {
            maxWidth: '15%',
            height: 20,
            borderRadius: Border.BorderRadiusM,
        },
        skeletonServiceBar: {
            width: '100%',
            height: 32,
            borderRadius: Border.BorderRadiusM,
        },
        skeletonTotalLabel: {
            maxWidth: '25%',
            height: 22,
            borderRadius: Border.BorderRadiusM,
        },
        skeletonTotalAmount: {
            maxWidth: '20%',
            height: 22,
            borderRadius: Border.BorderRadiusM,
        },
    })
);

export const SkeletonConsumptionByServices: React.FC = () => {
    const classes = useStyles();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: Spacing.SpacingS,
        }}>
            {[ 1, 2, 3, 4, 5 ].map((item) => (
                <Box
                    key={item}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: Spacing.SpacingMicro,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        <ApSkeleton
                            variant="rectangle"
                            className={classes.skeletonServiceName}
                        />
                        <ApSkeleton
                            variant="rectangle"
                            className={classes.skeletonServiceAmount}
                        />
                    </Box>
                    <ApSkeleton
                        variant="rectangle"
                        className={classes.skeletonServiceBar}
                    />
                </Box>
            ))}

            <Divider sx={{ marginTop: Spacing.SpacingXs }} />

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <ApSkeleton
                    variant="rectangle"
                    className={classes.skeletonTotalLabel}
                />
                <ApSkeleton
                    variant="rectangle"
                    className={classes.skeletonTotalAmount}
                />
            </Box>
        </Box>
    );
};
